module.exports = __webpack_public_path__ + "media/images/logo-background-ad0e86712e9d64070c983ce1da939827.png";